import { EventBroker } from "@frontend/lib/utils/event-broker";

export const GENERATE_QUICK_DOWNLOAD_EVENTS = {
    GENERATED: 'GENERATED'
}

export const generateQuickDownloadEventBroker = new EventBroker();
